// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yHV2x","timerContainer":"styles_timerContainer__q6ore","timer":"styles_timer__TTWJT"};